export type UserAvatarSize = 'small' | 'medium' | 'large'

export const userAvatarSizeStyles = (size: UserAvatarSize) => {
  switch (size) {
    case 'small':
      return { height: 20, width: 20, fontSize: '0.6rem' }
    case 'medium':
      return { height: 28, width: 28, fontSize: '0.8rem' }
    case 'large':
      return { height: 55, width: 55, fontSize: '1.5rem' }
  }
}
